import React from 'react';
import wb0 from '../img/Detail/Mind-Detail.jpg';
import './Detail.css';
const MindDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default MindDetail;